import React from "react";

const Hero = () => (
  <section id="about" className="bg-gray-900 text-white py-20 md:py-32">
    <div className="max-w-4xl mx-auto text-center px-4">
      <h2 className="text-4xl sm:text-6xl font-extrabold mb-4 font-inter leading-tight">
        <span className="text-indigo-400">Project Management Discipline</span> Applied to Code Architecture
      </h2>
      <p className="text-xl sm:text-2xl text-gray-300 mb-8">
        Experienced professional pivoting to <strong>Software Development</strong>, leveraging a background in complex project delivery (construction/store layouts) to build <strong>scalable, predictable, and robust React applications.</strong>
      </p>
      <div className="flex justify-center space-x-4">
        <a href="#projects" className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-8 rounded-lg shadow-xl transition duration-300 transform hover:scale-105">
          View Projects
        </a>
        <a href="#contact" className="bg-gray-700 hover:bg-gray-600 text-gray-200 font-bold py-3 px-8 rounded-lg shadow-xl transition duration-300 transform hover:scale-105">
          Get In Touch
        </a>
      </div>
    </div>
  </section>
);

export default Hero